import React from 'react';
import styled from 'styled-components';
import { fontWeight } from 'settings/style';

export const CategoryNameGloss = styled.span`
  font-weight: ${fontWeight.normal};
  font-size: 0.86em;
  color: #6d665d;
`;

type Props = {
  title?: string | null;
  translatedName?: string | null;
};

export function CategoryNameLabel({ title, translatedName }: Props) {
  const gloss = translatedName?.trim();

  if (!title && !gloss) {
    return null;
  }

  return (
    <>
      {title}
      {gloss ? <CategoryNameGloss> {gloss}</CategoryNameGloss> : null}
    </>
  );
}
